import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  FaUser,
  FaPhone,
  FaEnvelope,
  FaCalendar,
  FaVenusMars,
  FaCertificate,
  FaBriefcase,
  FaGraduationCap,
  FaMoneyBill,
  FaLanguage,
  FaFileImage,
  FaSyringe,
} from "react-icons/fa";
import { getBranchAction } from "../../Actions/BranchAction/BranchAction";
import { getPositionAction } from "../../Actions/BranchAction/PositionAction";
import { getRoleAction } from "../../Actions/RoleAction/RoleAction";
import { IoMdArrowRoundBack } from "react-icons/io";
import { IoArrowForward } from "react-icons/io5";
import { createUserAction } from "../../Actions/UserAction/UserAction";
import { FaComputerMouse } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

const CreateUser = () => {
  const getBranch = useSelector((state) => state.getBranch);
  const { branches } = getBranch;
  const getPosition = useSelector((state) => state.getPosition);
  const { positions } = getPosition;
  const getRole = useSelector((state) => state.getRole);
  const { roles } = getRole;

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getBranchAction());
    dispatch(getPositionAction());
    dispatch(getRoleAction());
  }, [dispatch]);

  const initialState = {
    en_name: "",
    krd_name: "",
    birth_date: "",
    gender: "",
    phone: "",
    secound_phone: "",
    close_phone: "",
    email: "",
    married: "",
    number_of_children: "",
    blood_group: "",
    date_of_commniucation: "",
    chronic_diseases: "",
    certificate: "",
    certificate_field: "",
    occupation_outside: "",
    work_place: "",
    job_tiltle: "",
    en_lang: "",
    krd_lang: "",
    ar_lang: "",
    computer_skills: "",
    branch_id: "",
    position_id: "",
    role_id: "",
    hourly_wage: "",
    extra_wage: "",
    status: "",
    images: [],
  };

  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { id, value, files } = e.target;
    if (files) {
      setFormData((prevState) => ({
        ...prevState,
        [id]: [...files],
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [id]: value,
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.en_name) newErrors.en_name = "English Name is required";
    if (!formData.krd_name) newErrors.krd_name = "Kurdish Name is required";
    if (!formData.birth_date) newErrors.birth_date = "Birth Date is required";
    if (!formData.gender) newErrors.gender = "Gender is required";
    if (!formData.phone) newErrors.phone = "Phone Number is required";
    if (!formData.branch_id) newErrors.branch_id = "Branch is required";
    if (!formData.position_id) newErrors.position_id = "Position is required";
    if (!formData.role_id) newErrors.role_id = "Role is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      dispatch(createUserAction(formData, handleClearInput));
    }
  };

  const handleClearInput = () => {
    setFormData(initialState);
  };
  const navigate = useNavigate();

  const fields = [
    {
      id: "en_name",
      label: "English Name",
      type: "text",
      placeholder: "English Name",
      icon: FaUser,
    },
    {
      id: "krd_name",
      label: "Kurdish Name",
      type: "text",
      placeholder: "Kurdish Name",
      icon: FaUser,
    },

    {
      id: "birth_date",
      label: "Birth Date",
      type: "date",
      placeholder: "mm/dd/yyyy",
      icon: FaCalendar,
    },
    {
      id: "gender",
      label: "Gender",
      type: "select",
      placeholder: "Select Gender",
      options: [
        { id: "Male", name: "Male" },
        { id: "Female", name: "Female" },
        { id: "Other", name: "Other" },
      ],
      icon: FaVenusMars,
    },
    {
      id: "phone",
      label: "Phone Number",
      type: "tel",
      placeholder: "Phone Number",
      icon: FaPhone,
    },
    {
      id: "secound_phone",
      label: "Second Phone",
      type: "tel",
      placeholder: "Second Phone",
      icon: FaPhone,
    },
    {
      id: "close_phone",
      label: "Phone Number Person Close",
      type: "tel",
      placeholder: "The phone number person close",
      icon: FaPhone,
    },
    {
      id: "email",
      label: "Email",
      type: "email",
      placeholder: "Email",
      icon: FaEnvelope,
    },
    {
      id: "married",
      label: "Married",
      type: "select",
      options: [
        { id: "Married", name: "Married" },
        { id: "Single", name: "Single" },
      ],
      placeholder: "Select Married",
      icon: FaVenusMars,
    },
    {
      id: "number_of_children",
      label: "Number Of Children",
      type: "number",
      placeholder: "Number Of Children",
      icon: FaUser,
    },
    {
      id: "blood_group",
      label: "Blood Group",
      type: "select",
      placeholder: "Blood Group",
      options: [
        { id: "A+", name: "A+" },
        { id: "A-", name: "A-" },
        { id: "B+", name: "B+" },
        { id: "B-", name: "B-" },
        { id: "O+", name: "O+" },
        { id: "O-", name: "O-" },
        { id: "AB+", name: "AB+" },
        { id: "AB-", name: "AB-" },
      ],
      icon: FaSyringe,
    },
    {
      id: "date_of_commniucation",
      label: "Date Of Commencement",
      type: "date",
      placeholder: "mm/dd/yyyy",
      icon: FaCalendar,
    },
    {
      id: "chronic_diseases",
      label: "Chronic Diseases",
      type: "text",
      placeholder: "Select Chronic Diseases",
      icon: FaSyringe,
    },
    {
      id: "certificate",
      label: "Certificate",
      type: "text",
      placeholder: "Select Certificate",
      icon: FaCertificate,
    },
    {
      id: "certificate_field",
      label: "Certificate Field",
      type: "text",
      placeholder: "Certificate Field",
      icon: FaGraduationCap,
    },
    {
      id: "occupation_outside",
      label: "Occupation Outside",
      type: "text",
      placeholder: "Occupation Outside",
      icon: FaBriefcase,
    },
    {
      id: "work_place",
      label: "Work Place",
      type: "text",
      placeholder: "Work Place",
      icon: FaBriefcase,
    },
    {
      id: "job_tiltle",
      label: "Job Title",
      type: "text",
      placeholder: "Job Title",
      icon: FaBriefcase,
    },

    {
      id: "en_lang",
      label: "English Language",
      type: "select",
      options: [
        { id: "Bad", name: "Bad" },
        { id: "Good", name: "Good" },
        { id: "Very Good", name: "Very Good" },
        { id: "Perfect", name: "Perfect" },
      ],
      placeholder: "Select Level Language",
      icon: FaLanguage,
    },
    {
      id: "krd_lang",
      label: "Kurdish Language",
      type: "select",
      placeholder: "Select Level Language",
      options: [
        { id: "Bad", name: "Bad" },
        { id: "Good", name: "Good" },
        { id: "Very Good", name: "Very Good" },
        { id: "Perfect", name: "Perfect" },
      ],
      icon: FaLanguage,
    },
    {
      id: "ar_lang",
      label: "Arabic Level",
      type: "select",
      options: [
        { id: "Bad", name: "Bad" },
        { id: "Good", name: "Good" },
        { id: "Very Good", name: "Very Good" },
        { id: "Perfect", name: "Perfect" },
      ],
      placeholder: "Select Level Language",
      icon: FaLanguage,
    },
    {
      id: "computer_skills",
      label: "Computer Skills",
      type: "select",
      options: [
        { id: "Bad", name: "Bad" },
        { id: "Good", name: "Good" },
        { id: "Very Good", name: "Very Good" },
        { id: "Perfect", name: "Perfect" },
      ],
      placeholder: "Select Computer Skills",
      icon: FaComputerMouse,
    },
    {
      id: "branch_id",
      label: "Branch",
      type: "select",
      placeholder: "Select Branch",
      options: branches,
      icon: FaBriefcase,
    },
    {
      id: "position_id",
      label: "Position",
      type: "select",
      placeholder: "Select Position",
      options: positions,
      icon: FaBriefcase,
    },
    {
      id: "role_id",
      label: "Role",
      type: "select",
      placeholder: "Select Role",
      options: roles,
      icon: FaBriefcase,
    },
    {
      id: "hourly_wage",
      label: "Hourly Wage",
      type: "number",
      placeholder: "Hourly Wage",
      icon: FaMoneyBill,
    },
    {
      id: "extra_wage",
      label: "Extra Wage",
      type: "number",
      placeholder: "Extra Wage",
      icon: FaMoneyBill,
    },
    {
      id: "status",
      label: "Status",
        type: "select",
      options: [
        { id: "active", name: "active" },
        { id: "inactive", name: "inactive" },

      ],
      placeholder: "Select Computer Skills",
      icon: FaComputerMouse,
    },
  ];

  const createUser = useSelector((state) => state.createUser);
  const { error, loading } = createUser;
  return (
    <>
      <div className="max-w-7xl my-4 mx-auto p-6 bg-white rounded-lg shadow-lg">
        <div className="flex justify-between gap-2 items-center">
          <button className="btn-indigo w-1/12 group justify-between" onClick={() => navigate(-1)}>
            Back
            <p className="group-hover:-translate-x-1 duration-500">
              <IoMdArrowRoundBack />
            </p>
          </button>
          <h2 className="text-2xl font-semibold mb-6">User</h2>
        </div>
        <form
          onSubmit={handleSubmit}
          className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6"
        >
          {fields.map((field) => (
            <div key={field.id} className="flex flex-col">
              <label
                htmlFor={field.id}
                className="mb-2 text-sm font-medium flex items-center"
              >
                {field.icon && <field.icon className="mr-2" />}
                {field.label}
              </label>
              {field.type === "select" ? (
                <>
                  <select
                    id={field.id}
                    value={formData[field.id]}
                    onChange={handleChange}
                    className="border border-gray-300 rounded-lg p-2"
                  >
                    <option value="">{field.placeholder}</option>
                    {field.options.map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                  {errors[field.id] && (
                    <p className="text-red-500">{errors[field.id]}</p>
                  )}
                </>
              ) : (
                <>
                  <input
                    type={field.type}
                    id={field.id}
                    value={formData[field.id]}
                    onChange={handleChange}
                    className="border border-gray-300 rounded-lg p-2"
                    placeholder={field.placeholder}
                  />

                  {error ? (
                    <p className="text-red-500">{error[field.id]}</p>
                  ) : (
                    <p className="text-red-500">{errors[field.id]}</p>
                  )}
                </>
              )}
            </div>
          ))}
          <div className="lg:col-span-4 md:col-span-3">
            <label
              htmlFor="images"
              className="mb-2 text-sm font-medium flex items-center"
            >
              <FaFileImage className="mr-2" />
              Images
            </label>
            <input
              type="file"
              id="images"
              multiple
              onChange={handleChange}
              className="border border-gray-300 rounded-lg p-2"
            />
          </div>
          <button
            type="submit"
            className={
              loading
                ? "btn-indigo lg:w-4/12 opacity-50 cursor-not-allowed  overflow-hidden group items-center justify-between"
                : " btn-indigo lg:w-4/12  overflow-hidden group items-center justify-between"
            }
            disabled={loading}
          >
            {loading ? "Save" : "Save"}

            <p
              className={
                loading
                  ? "group-hover:translate-x-20 ease-in-out mt-0.5 duration-700 mr-2  "
                  : "group-hover:translate-x-1 mt-0.5 duration-300 mr-2  "
              }
            >
              <IoArrowForward />
            </p>
          </button>
        </form>
      </div>

      <div className="pb-10"></div>
    </>
  );
};

export default CreateUser;
